'use client';

import { useContext } from 'react';
import { AppContext } from '@/src/context/AppContext';
import { getEmailVerificationStatus } from '@/src/lib/emailVerification';
import styles from './EmailVerificationBanner.module.css';

/**
 * Persistent "verify your email" notice — sits directly below the top nav
 * on every page (mounted in both BarTop.jsx and BarTopNewSite.jsx, right
 * after their nav markup) for as long as the logged-in player's email is
 * confirmed unverified. Unlike CouponCashier's CouponErrorModal (a
 * dismissible popup shown once per coupon-click), this does not go away
 * when closed — it only disappears once the account is actually verified.
 *
 * Read-only status display; does not touch the coupon email-verification
 * gate itself (CouponCashier/QuickDepositSection) — that business rule
 * stays exactly as documented in
 * promo-operations-platform/docs/CASINO_CLIENT_ONBOARDING_REGRESSIONS_SR.md.
 */
export default function EmailVerificationBanner() {
  const { user } = useContext(AppContext);

  // Only render when the status is reliably known to be false. `null`
  // (not yet loaded / unknown) and `true` (verified) both render nothing.
  if (getEmailVerificationStatus(user) !== false) return null;

  return (
    <div className={styles.banner} role="status">
      <span className={styles.text}>
        Please verify your email address — check your inbox for the
        verification link. Some promotions can&apos;t be claimed until it&apos;s
        confirmed.
      </span>
    </div>
  );
}
